import axios from 'axios';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import {
  createStaticGlobals,
  createApplicationOption,
  createFlagsOption,
  createTranslationsOption,
} from '@garmin/vue-static-global';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import App from './App.vue';
import router from './router';
import { requestSecurityInterceptor } from './interceptors/requestSecurityInterceptor';

const { application } = window;

const app = createApp(App);
requestSecurityInterceptor(axios);

/* Pinia Setup */
const pinia = createPinia();
app.use(pinia);

Sentry.init({
  app,
  dsn: 'https://f47e84e74b2047b78c580b713a2ac9f0@o430870.ingest.sentry.io/6627611',
  integrations: [new Integrations.BrowserTracing()],
  release: `${application.appName}@${application.appVersion}`,
  environment: application.environment,
  logErrors: true,
  // Set tracesSampleRate to 1.0 to capture 100% (recommended for prod)
  // of transactions for performance monitoring.
  // https://docs.sentry.io/platforms/javascript/configuration/sampling/
  tracesSampleRate: 1.0,
  // track child components
  tracingOptions: {
    trackComponents: true,
  },
});

/* Static Globals Setup */
app.use(createStaticGlobals, [
  createApplicationOption(window.application),
  createFlagsOption(window.flags),
  createTranslationsOption(window.translations),
]);

/* Router Setup */
app.use(router, app);

app.mount('#app');
